import * as React from 'react'
import Svg, { Path } from 'react-native-svg'

const CloseIcon = ({ width = 20, height = 28, color = '#006B5C' }) => (
	<Svg width={width} height={height} viewBox="0 0 29 28" fill="none">
		<Path d="M2.68945 26.3424L26.8086 2.22322" stroke={color} strokeWidth={4} />
		<Path d="M2 2L26.1192 26.1192" stroke={color} strokeWidth={4} />
	</Svg>
)

export default CloseIcon
